module.exports = __webpack_public_path__ + "img/share-mode-flow2.85a29cc4.png";